<script>
import { authMethods } from '@state/helpers'
import appConfig from '@src/app.config'
import { ErrorWrapper } from '@utils/error-handler'
import Layout from '@layouts/main'

export default {
  page: {
    title: 'Change Password',
    meta: [
      { name: 'description', content: `Change Password to ${appConfig.title}` },
    ],
  },
  components: { Layout },
  data() {
    return {
      oldPassword: '',
      newPassword: '',
      newPassword1: '',
      error: null,
      tryingToChange: false,
      isChangeError: false,
      isSuccess: false,
      successMessage: null,
      prevent: null,
      passwordError: false,
    }
  },
  computed: {
    validation() {
      const state = this.newPassword1 === this.newPassword ? null : false
      if (this.newPassword !== '') {
        if (state === false) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.prevent = false
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.prevent = true
        }
        return state
      } else {
        return null
      }
    },
  },
  methods: {
    ...authMethods,
    tryToChange() {
      this.tryingToChange = true
      this.error = null
      if (
        this.newPassword.match(
          '^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[^]).{8,}'
        )
      ) {
        this.passwordError = false
      } else {
        this.passwordError = true
      }
      if (this.prevent && !this.passwordError) {
        return this.changePassword({
          oldPassword: this.oldPassword,
          newPassword: this.newPassword,
        })
          .then((data) => {
            this.tryingToChange = false
            this.isChangeError = false
            this.isSuccess = true
            this.successMessage = data.msg
          })
          .catch((error) => {
            this.tryingToChange = false
            var getError = new ErrorWrapper(error)
            this.error = getError.message
            this.isChangeError = true
            this.isSuccess = false
          })
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card">
          <div class="card-body p-4">
            <div class="text-center mb-4">
              <h4 class="text-uppercase mt-0 mb-3">Change Password</h4>
            </div>
            <b-alert
              v-model="isChangeError"
              variant="danger"
              v-html="error"
            ></b-alert>

            <b-alert
              v-model="isSuccess"
              variant="success"
              v-html="successMessage"
            ></b-alert>

            <b-form @submit.prevent="tryToChange">
              <b-form-group label="Current Password" label-for="oldPassword">
                <b-form-input
                  id="oldPassword"
                  v-model="oldPassword"
                  type="password"
                  required
                  placeholder="Enter Current Password"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="New Password" label-for="newPassword1">
                <b-form-input
                  id="newPassword1"
                  v-model="newPassword1"
                  type="password"
                  required
                  placeholder="Enter New Password"
                ></b-form-input>
                <small
                  >Password should be atleast 8 characters long, should include
                  1 uppercase, 1 lowercase, 1 special symbol and 1 number</small
                >
                <br />
                <p v-if="passwordError" style="color: red"
                  >Please add a valid new password</p
                >
              </b-form-group>

              <b-form-group
                label="Confirm New Password"
                label-for="newPassword"
              >
                <b-form-input
                  id="newPassword"
                  v-model="newPassword"
                  type="password"
                  required
                  :state="validation"
                  placeholder="Confirm New Password"
                ></b-form-input>
                <b-form-invalid-feedback :state="validation"
                  >Confirm New Password should be same as new
                  password</b-form-invalid-feedback
                >
              </b-form-group>

              <b-form-group id="button-group" class="mt-4">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Change Password</b-button
                >
              </b-form-group>
            </b-form>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
